import React from 'react';
import { Form, Input, Button, Upload, Select } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';


const { Option } = Select;

const CustomerForm = ({ form, onFinish, initialValues, isEditing, roles = [] }) => {


  const navigate = useNavigate();
  const validateName = (_, value) => {
    if (value && /\d/.test(value)) {
      return Promise.reject(new Error('Le nom ne doit pas contenir de chiffres'));
    }
    return Promise.resolve();
  };

  const handleLogoUpload = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(file);
    });
  };

  const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  };

  const ROLE_LABELS = {
    'superadmin': 'Administrateur',
    'client': 'Client'
  };

  return (
    <Form
      {...formItemLayout}
      form={form}
      name="customerForm"
      onFinish={onFinish}
      initialValues={initialValues}
      layout="horizontal"
      className="max-w-3xl mx-auto bg-white p-8 rounded-lg shadow-md"
    >
      <h2 className='font-semibold pb-6 text-xl'>
        {isEditing ? 'Modifier les informations du client :' : 'Veuillez saisir les informations suivantes :'}
      </h2>
      <Form.Item
        name="company_name"
        label="Nom entreprise"
        rules={[{ required: true, message: "Le nom de l'entreprise est requis" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="full_name"
        label="Nom et Prénom"
        rules={[
          { validator: validateName }
        ]}
      >
        <Input />
      </Form.Item>

      {!isEditing && (
        <Form.Item
          name="role_id"
          label="Rôle"
          rules={[{ required: true, message: "Le rôle est requis" }]}
        >
          <Select placeholder="Sélectionnez un rôle">
            {roles.map(role => (
              <Option key={role.role_id} value={role.role_id}>
                {ROLE_LABELS[role.name] || role.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      )}

      <Form.Item
        name="phone_number"
        label="Numéro contact"
        rules={[
          { pattern: /^\d+$/, message: 'Le numéro de contact doit contenir uniquement des chiffres' }
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="email"
        label="Adresse mail"
        rules={[
          { required: true, message: "L'adresse email est requise" },
          { type: 'email', message: "L'adresse email n'est pas valide" }
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="address"
        label="Adresse du siège"
      >
        <Input.TextArea />
      </Form.Item>

      <Form.Item
        name="company_logo"
        label="Logo entreprise"
        valuePropName="fileList"
        getValueFromEvent={(e) => {
          if (Array.isArray(e)) {
            return e;
          }
          return e && e.fileList;
        }}
      >
        <Upload 
          name="logo" 
          listType="picture"
          maxCount={1}
          accept="image/*"
          beforeUpload={(file) => {
            handleLogoUpload(file).then(dataUrl => {
              const fileList = form.getFieldValue('company_logo') || [];
              fileList[0] = {
                uid: '-1',
                name: file.name,
                status: 'done',
                url: dataUrl,
                thumbUrl: dataUrl,
              };
              form.setFieldsValue({ company_logo: fileList });
            });
            return false; // Prevent default upload behavior
          }}
        >
          <Button icon={<UploadOutlined />}>Choisir un logo</Button>
        </Upload>
      </Form.Item>

      {!isEditing && (
        <>
          <Form.Item
            name="password"
            label="Mot de passe"
            rules={[
              { required: true, message: 'Le mot de passe est requis' },
              { min: 8, message: 'Le mot de passe doit contenir au moins 8 caractères' }
            ]}
            hasFeedback
          >
            <Input.Password autoComplete="new-password"  />
          </Form.Item>

          <Form.Item
            name="confirmPassword"
            label="Confirmer MDP"
            dependencies={['password']}
            hasFeedback
            rules={[
              { required: true, message: 'Veuillez confirmer le mot de passe' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Les mots de passe ne correspondent pas'));
                },
              }),
            ]}
          >
            <Input.Password autoComplete="new-password"  />
          </Form.Item>
        </>
      )}

      <Form.Item wrapperCol={{ offset: 6, span: 18 }}>
        <div className='w-full flex justify-between'>
          <Button type="danger" htmlType="button" 
            className='bg-red-500 text-white hover:bg-red-400 px-4 py-2 rounded-md'
            onClick={() => {
            isEditing ? 
            navigate(`/admin/client/${initialValues.user_id}/show-info`) 
            : navigate('/admin/client/all')
          }}>
            Annuler
          </Button>
          <Button type="primary" htmlType="submit" className="bg-indigo-500 hover:bg-indigo-600">
            {isEditing ? 'Mettre à jour le client' : 'Créer le client'}
          </Button>
        </div>
      </Form.Item>
    </Form>
  );
};

export default CustomerForm;